<crm-tree-select
  class="block {{ styleClass }}"
  [options]="filteredDirections"
  [(selectedItem)]="selectedFilteredDirection"
  [label]="label"
  [disabled]="disabled"
  [groupsDisabled]="groupsDisabled"
  [scrollHeight]="scrollHeight"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [filter]="true"
  [sort]="sort"
  (panelShow)="panelShow.emit()"
  (panelHide)="panelHide.emit()"
  (selectedItemChange)="selectDirectionsHandler($event)"
  display="comma"
  selectionMode="single"></crm-tree-select>
